import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import DmxControllerList from '../../components/Lists/DmxControllerList';
import { getDmxControllers } from '../../store/actions';

class DmxControllers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      controllerList: null,
    };
  }

  componentDidMount() {
    this.props.getDmxControllers(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.controllers !== prevProps.controllers) {
      this.setState({ controllerList: this.props.controllers });
    }
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ controllerList: null });
    this.props.getDmxControllers(this.state.user);
  }

  render() {
    if (!this.state.controllerList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/createDmxController">{this.props.t('Crear controlador')}</Link>
          </Button>
          <DmxControllerList controllerList={this.state.controllerList} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { controllers } = state.getDmxControllers;
  return { controllers };
};

export default withRouter(connect(mapStateToProps, { getDmxControllers })(withNamespaces()(DmxControllers)));
